/* eslint-disable no-unused-vars */
export default {
    init() {
			if (window.addEventListener) {
				// For standards-compliant web browsers
				window.addEventListener("message", this.processCordovaWrapperMessage, false);
			}
			else {
				window.attachEvent("onmessage", this.processCordovaWrapperMessage);
			}
    },
    processCordovaWrapperMessage(evt)
    {
        var message = evt.data;
	
        if (!message.indexOf) return;

        console.log("*** Mensaje recibido: " + message);

        if (message.indexOf("SET_LOCAL_STORAGE:") == 0) {									
						window.$vue.$emit('set-login-info', message.split(':')[2]);
				}

        if (message.indexOf("NE_DEVICE_UUID:") == 0) {
            window.$store.commit('icoev/setDeviceUuid', message.substring(15));
            window.$vue.$emit('device-info-updated');
        }

        if (message.indexOf("NE_DEVICE_PLATFORM:") == 0) {
            window.$store.commit('icoev/setDevicePlatform', message.substring(19));
            window.$vue.$emit('device-info-updated');
        }

        if (message.indexOf("NE_DEVICE_VERSION:") == 0) {
						window.$store.commit('icoev/setDeviceVersion', message.substring(18));
            window.$vue.$emit('device-info-updated');
        }

        if (message.indexOf("NE_DEVICE_TOKEN:") == 0) {
            window.$store.commit('icoev/setDeviceToken', message.substring(16));
            window.$vue.$emit('device-info-updated');
        }

        if (message.indexOf("NE_PUSH:") == 0) {
						var json = message.substring(8);

						json = json.replaceAll('\\"', '"');
						json = json.replaceAll("\":\"{", "\":{");
						json = json.replaceAll("}\",", "},");
						
						var obj = JSON.parse(json);
						
						var section = obj.additionalData ? obj.additionalData.payload.type : obj.data.payload.type;

						window.$vue.$emit('notification-received', section);
        }

        if (message.indexOf("NE_RESUME") == 0) {
            window.$vue.$emit('ne_resume');
        }

        if (message.indexOf("NE_AWAKE:") == 0) {
            window.$vue.$emit('ne_awake', message.substring(9));
        }

        if (message.indexOf("NE_BACKBUTTON") == 0) {
						window.$vue.$emit('ne_backbutton');
        }
    },
    sendCordovaWrapperMessage(message) {
        if (window !== parent) {
						parent.postMessage(message, "*");
        }
    },
    initCompleted() {
        this.sendCordovaWrapperMessage('INIT_COMPLETED');

				/*var me = this;

				var timerId = setTimeout(function(){
					me.sendCordovaWrapperMessage("NE_DEVICE_UUID:E2F7E6C0-D6D5-4F51-9FB3-CD730923102E");
					me.sendCordovaWrapperMessage("NE_DEVICE_PLATFORM:browser");
					me.sendCordovaWrapperMessage("NE_DEVICE_VERSION:1.0.7");
					me.sendCordovaWrapperMessage("NE_DEVICE_TOKEN:740f4707bebcf74f9b7c25d48e3358945f6aa01da5ddb387462c7eaf61bb78ad");
					//me.sendCordovaWrapperMessage("NE_AWAKE:10");
					//me.sendCordovaWrapperMessage("NE_AWAKE:10.001");
					//me.sendCordovaWrapperMessage("NE_BACKBUTTON");
          clearTimeout(timerId);
        }, 5000);*/
    },
		setLocalStorageItem(key, value) {			
        this.sendCordovaWrapperMessage('SET_LOCAL_STORAGE:' + key + ':' + value);
		},
		removeLocalStorageItem(key) {			
        this.sendCordovaWrapperMessage('REMOVE_LOCAL_STORAGE:' + key);
		},
    initializationProgress(step) {			
        this.sendCordovaWrapperMessage('INITIALIZATION_PROGRESS:' + step);
		},
    readyToProcessNotifications() {			
        this.sendCordovaWrapperMessage('READY_TO_PROCESS_NOTIFICATIONS');
		},
    cancelProcessNotifications() {			
        this.sendCordovaWrapperMessage('CANCEL_PROCESS_NOTIFICATIONS');
		},
		setTopbarColor(color) {			
        this.sendCordovaWrapperMessage('TOPBARCOLOR:' + color);
		},
		openUrl(url) {			
        this.sendCordovaWrapperMessage('OPEN_URL:' + url);
		},
		downloadUrl(filename, url) {			
        this.sendCordovaWrapperMessage('DOWNLOAD_URL:' + filename + ':' + url);
		},
}